module.exports = __webpack_public_path__ + "img/68240_egalsoft_150x150.d8b452d0.jpg";